import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import { COMMON_TICKET_URL } from '@shared/utils/support-urls/supportUrls';
import * as React from 'react';

import styles from './InternalHelpSection.module.css';

const InternalHelpSection = React.memo((): React.ReactElement => {
  return (
    <section
      className={styles.section}
      data-testid="internal-help-section"
      aria-labelledby="internal-help-title"
    >
      <h3 className="heading-01" id="internal-help-title">
        Need help with CAE Connect?
      </h3>
      <p className={styles.description}>
        If you are having issues or need assistance with CAE Connect,{' '}
        <CobaltLink
          href={COMMON_TICKET_URL}
          target="_blank"
          rel="noopener noreferrer"
          inline
        >
          contact IT support{' '}
          <CobaltIconExternalLinkOutline aria-hidden="true" />
        </CobaltLink>
        .
      </p>
    </section>
  );
});

InternalHelpSection.displayName = 'InternalHelpSection';

export { InternalHelpSection };
